import { render, staticRenderFns } from "./Volta.vue?vue&type=template&id=bdbf7838&scoped=true"
import script from "./Volta.vue?vue&type=script&lang=js"
export * from "./Volta.vue?vue&type=script&lang=js"
import style0 from "./Volta.vue?vue&type=style&index=0&id=bdbf7838&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bdbf7838",
  null
  
)

export default component.exports